/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { PostAdministrationOrganizationSitesRemoteAccessRequest } from '../../models/post-administration-organization-sites-remote-access-request';

export interface PostAdministrationRemoteAccessToSite$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;
      body: PostAdministrationOrganizationSitesRemoteAccessRequest
}

export function postAdministrationRemoteAccessToSite(http: HttpClient, rootUrl: string, params: PostAdministrationRemoteAccessToSite$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, postAdministrationRemoteAccessToSite.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

postAdministrationRemoteAccessToSite.PATH = '/administration/organization-sites/{organizationSiteKey}/remote-accesses';
